import TileLayer from "ol/layer/Tile"
import { MAP_TYPE_IDS } from "./data"
import { OSM, XYZ } from "ol/source"

export const useTiles = () => ([
  new TileLayer({
    key: MAP_TYPE_IDS.OPEN_STREETMAP,
    type: 'tile',
    visible: true,
    source: new OSM()
  }),
  new TileLayer({
    key: MAP_TYPE_IDS.GOOGLE_HYBRID,
    type: 'tile',
    visible: false,
    source: new XYZ({
      url: 'https://mt{0-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&hl=en',
      attributions: 'Map data &copy;2025 Google',
      maxZoom: 22
    })
  }),
  new TileLayer({
    key: MAP_TYPE_IDS.GOOGLE_SATELLITE,
    type: 'tile',
    visible: false,
    source: new XYZ({
      url: 'https://mt{0-3}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}&hl=en',
      attributions: 'Map data &copy;2025 Google',
      maxZoom: 22
    })
  }),
  new TileLayer({
    key: MAP_TYPE_IDS.GOOGLE_TERRAIN,
    type: 'tile',
    visible: false,
    source: new XYZ({
      url: 'https://mt{0-3}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}&hl=en',
      attributions: 'Map data &copy;2025 Google',
      maxZoom: 22
    })
  }),
  new TileLayer({
    key: MAP_TYPE_IDS.GOOGLE_ROADMAP,
    type: 'tile',
    visible: false,
    source: new XYZ({
      url: 'https://mt{0-3}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=en',
      attributions: 'Map data &copy;2025 Google',
      maxZoom: 22
    })
  })
])